import { component } from 'picoapp';

export default component(async (node, ctx) => {
  const link = node.querySelector('[data-link]');
  const linkOutput = node.querySelector('[data-link-output]');

  const init = (response) => {
    if (response.products.length === 0) return;

    const { permaId } = response;
    node.hidden = false;

    const params = {
      wkShareService: 'link',
      wkShare: permaId,
      wkShareImage: response.products[0].images.src,
    };

    const wishlistLink = window.WishlistKing.toolkit.getShareLink(params);
    linkOutput.innerText = wishlistLink;

    const { title, text } = JSON.parse(link.dataset.share);
    const shareData = {
      title,
      text,
      url: wishlistLink,
    };

    const handleClick = async (event) => {
      event.preventDefault();
      link.href = wishlistLink;

      if (navigator.share && navigator.canShare(shareData)) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(link.href);
        link.textContent = window.theme.strings.wishlist.copied;

        linkOutput.classList.remove('hidden');

        setTimeout(() => {
          link.textContent = link.dataset.original;
        }, 1500);
      }
    };

    link.addEventListener('click', handleClick);
  };

  ctx.on('wishlist:loaded', ({ response }) => {
    init(response);
  });
});
